import gql from 'graphql-tag';

export const SearchIncidentIssue = gql`
  query SearchIncidentIssue($input: IncidentIssueWithCacheConnectionInput) {
    searchIncidentIssue {
      incidentIssueTableConnection(input: $input) {
        totalCount
        edges {
          node {
            createdAt
            createdBy
            crewInfo
            crewInvolved
            description
            dispatcherFirstName
            dispatcherId
            dispatcherLastName
            driverEmployeeId
            driverFirstName
            driverId
            driverLastName
            id
            incidentDatetime
            incidentOccurance
            incidentOccuranceOther
            incidentWitnesses
            managerFirstName
            managerId
            managerLastName
            medicalAttentionType
            medicalInjuries
            medicalNeeded
            outboundDatetime
            outboundFlightName
            outboundFlightNumber
            propertyDamage
            propertyDamageDescription
            recoveryInfo
            samsaraCameraWorking
            station
            tripFlightNumber
            tripLoopName
            tripId
            tripScheduled
            tripServicerIataAirlineCode
            updatedAt
            updatedBy
            vehicleId
            vehicleTrackingId
          }
          cursor
        }
        pageInfo {
          startCursor
          endCursor
          hasPreviousPage
          hasNextPage
        }
      }
    }
  }
`;
